import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/UserMinus.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: n }));
o.displayName = "UserMinusIcon";
const m = o;
export {
  m as UserMinus,
  o as UserMinusIcon
};
